export type TokenClaims = {
	sub?: string
	preferred_username?: string
	email?: string
	realm_access?: {
		roles?: string[]
	}
	resource_access?: Record<
		string,
		{
			roles?: string[]
		}
	>
}

export type AuthPrincipal = {
	subject: string
	username?: string
	email?: string
	roles: string[]
}

export const principalFromToken = (
	token: TokenClaims | undefined,
	clientId: string,
): AuthPrincipal | null => {
	if (!token?.sub) {
		return null
	}
	const roles = new Set<string>(token.realm_access?.roles ?? [])
	for (const role of token.resource_access?.[clientId]?.roles ?? []) {
		roles.add(role)
	}
	return {
		subject: token.sub,
		username: token.preferred_username,
		email: token.email,
		roles: [...roles].sort(),
	}
}
